<template>
    <div class="card">
        <div class="row">
            <Toast/>
            <DataTable :value="all_ship_agents" :paginator="true" :rows="10"
            :paginatorTemplate="paginatorTemplate"
            :rowsPerPageOptions="[10,20,50]" responsiveLayout="scroll" 
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            stripedRows 
            :globalFilterFields="['name']"
            v-model:filters="filters"
            :loading="loading" >
                <template #header>
                    <div class="row">
                        <div class="table-header flex flex-column md:flex-row md:justify-content-end">
                            <span class="p-input-icon-left ">
                                <i class="pi pi-search" />
                                <InputText id="filter_ship_agents" v-model="filters['global'].value" placeholder="Keyword Search" class="input_small"/>
                            </span>
                        </div>
                    </div>
                </template>
                <Column header="Name" field="name" :sortable="true" style="min-width: 19rem;"/>
                <Column header="Cruise Lines" field="id_cruise_line" :sortable="true">
                    <template #body="slotProps">
                        <span v-for="item in slotProps.data.id_cruise_line" :key="item"> 
                            <Chip :label="item.name" class="me-2 mb-1 mt-1"/> 
                        </span>
                    </template>
                </Column> 
                <Column v-if="$can('change','ship_agent')" header="Edit" style="width: 7rem;">
                    <template #body="slotProps">
                        <Button data-cy="edit_button" icon="pi pi-pencil" class="p-button-rounded p-button-info p-button-outlined" @click="edit_ship_agent(slotProps.data)"/>
                    </template>
                </Column>
                <Column v-if="$can('delete','ship_agent')" header="Delete" style="width: 7rem;">
                    <template #body="slotProps">
                        <Button data-cy="delete_button" icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-outlined" @click="confirm_delete_ship_agent(slotProps)"/>
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>

    <Dialog data-cy="edit_ship_agent_modal" v-model:visible="ship_agent_dialog" :breakpoints="{'960px': '90vw'}" :style="{width: '50vw'}" header="Ship Agent Details" :modal="true" class="p-fluid">
        <div class="container">
            <div class="row justify-content-center mt-3">
                <div class="col-10 md:col-12">
                    <div class="p-float-field">
                        <label for="name" class="ps-1 pb-1"> <strong> Name </strong> </label>
                        <InputText id="name" v-model.trim="ship_agent.name" required="true" autofocus :class="{'p-invalid': submitted && !ship_agent.name || ship_agent_errors.name}" @input="ship_agent.name = $event.target.value.toUpperCase()"/>
                        <small v-if="Object.keys(ship_agent_errors).length !== 0 && ship_agent_errors.name" class="p-error"><span v-for="error in ship_agent_errors.name" :key="error">{{error}}<br></span></small>
                        <small class="p-error" v-if="submitted && !ship_agent.name">Name is required.</small>
                    </div>
                </div>
            </div>
            <!--
            <div class="row justify-content-center">
                <div class="col-10 md:col-12">
                    <div class="p-float-field">
                        <label for="cruise_line" class="ps-1 pb-1"> <strong>Ship</strong> </label>  
                        <Dropdown id="id_cruise_line" v-model="ship_agent.id_cruise_line" :options="all_cruise_lines" optionLabel="ship_agent" :filter="true">
                            <template #value="slotProps">
                                <div v-if="slotProps.value && !slotProps.value.value">
                                    <span>{{slotProps.value.name}}</span>
                                </div>
                                <div v-else-if="slotProps.label && slotProps.value.value">
                                    <span>{{slotProps.option.name}}</span>
                                </div>
                            </template>
                            <template #option="slotProps">
                                <div>{{slotProps.option.name}} </div>
                            </template>
                        </Dropdown>
                        <small v-if="Object.keys(ship_agent_errors).length !== 0 && ship_agent_errors.id_cruise_line" class="p-error"><span v-for="error in ship_agent_errors.id_cruise_line" :key="error">{{error}}<br></span></small>
                    </div>
                </div>
            </div>
            -->
            <div class="row">
                <div class="col-10 md:col-12">
                    <span v-for="cruise_line in ship_agent.id_cruise_line" :key="cruise_line">
                        <Chip :label="cruise_line.name" class="mr-2 mb-2"/>
                    </span>
                    <ListBox v-model="ship_agent.id_cruise_line" :options="all_cruise_lines" optionLabel="name" :multiple="true" :filter="true" listStyle="max-height:250px;"/>
                </div>
            </div> 
        </div>
        <template #footer>
            <Button label="Cancel" class="p-button-text" @click="hide_ship_agent_dialog"/>
            <Button data-cy="save_edit_ship_agent" label="Save" @click="save_ship_agent" />
        </template>
        
    </Dialog>

    <Dialog v-model:visible="delete_ship_agent_dialog" :style="{width: '450px'}" header="Confirm" :modal="true">
        <div class="confirmation-content">
            <span v-if="ship_agent">Are you sure you want to delete <b>{{ship_agent.name}}</b>?</span>
        </div>
        <template #footer>
            <Button label="No" class="p-button-text" @click="delete_ship_agent_dialog = false"/>
            <Button data-cy="confirm_delete_button" label="Yes" @click="deleteShip_agent" />
        </template>
    </Dialog>

</template>

<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext';
import Button from 'primevue/button'
import Toast from 'primevue/toast'
import Dialog from 'primevue/dialog'
import Chip from 'primevue/chip'
//import Dropdown from 'primevue/dropdown'
import ListBox from 'primevue/listbox'
import { FilterMatchMode } from 'primevue/api';
import { required } from '@vuelidate/validators'
import { useVuelidate } from "@vuelidate/core";

export default {
    setup: () => ({ v$: useVuelidate() }),
    name: "TableShip_agents",    
    components: {
        DataTable,
        Column,
        //Dropdown,
        InputText,
        Button,
        Toast,
        Dialog,
        ListBox,
        Chip
    },
    data() {
        return {
            ship_agent: {},
            ship_agent_errors: {},
            ship_agent_dialog: false,
            delete_ship_agent_dialog: false,
            submitted: false,
            filters: {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            },
            loading: false,
            paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        }
    },
    async mounted() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
        this.loading = true
        await this.$store.dispatch('load_all_ship_agents')
        this.loading = false
    },

    async unmounted(){
        window.removeEventListener('resize', this.handleResize);
    },

    computed: {
        all_ship_agents: function() {
            return this.$store.getters.all_ship_agents
        },
        all_cruise_lines: function(){
            return this.$store.getters.all_cruise_lines
        },
        get_ship_agent_errors: function() {
            return this.$store.getters.get_ship_agent_errors
        },
        get_delete_ship_agent_status: function() {
            return this.$store.getters.get_delete_ship_agent_status
        }
    },
    methods: {

        async handleResize(){
            if (window.innerWidth <= 767){
                this.paginatorTemplate = "CurrentPageReport PrevPageLink NextPageLink"
            } else {
                this.paginatorTemplate = "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            }
        },

        confirm_delete_ship_agent(ship_agent) {
            this.ship_agent = ship_agent.data;
            this.delete_ship_agent_dialog = true;
        },
        async deleteShip_agent() {
            await this.$store.dispatch('delete_ship_agent', this.ship_agent.id)
            if (!this.get_delete_ship_agent_status){
                this.$toast.removeAllGroups();
                this.$toast.add({severity:'success', summary: 'Successful', detail: 'Ship agent deleted', life: 3000});
            }else{
                this.$toast.removeAllGroups();
                this.$toast.add({severity:'error', summary: 'Error', detail: "Ship agent can't be deleted", life: 3000});
            }
            this.delete_ship_agent_dialog = false;
            
        },
        edit_ship_agent(ship_agent) {
            this.ship_agent = {...ship_agent};
            
            this.ship_agent_dialog = true;
            
        },
        async save_ship_agent() {
            this.submitted = true;
			if (this.ship_agent.name.trim()) {

                await this.$store.dispatch('update_ship_agent', this.ship_agent)
                this.ship_agent_errors = this.get_ship_agent_errors
                if(Object.keys(this.ship_agent_errors).length === 0){
                    this.hide_ship_agent_dialog()
                    this.ship_agent = {};
                    this.$toast.removeAllGroups();
                    this.$toast.add({severity:'success', summary: 'Successful', detail: 'Ship agent modified', life: 3000});
                }
            }
        },
        hide_ship_agent_dialog() {
            this.ship_agent_dialog = false;
            this.submitted = false;
        },
    },
    validations() {
        return {
            name: { required },
            id_cruise_line: { required },
        }
    },
}
</script>

<style scoped>
.card {
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12);
    border-radius: 10px;
    margin-bottom: 1rem;
}
:deep(.p-chip-text){
    font-size: 11px;
}

.table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}

:deep(.p-inputtext){
    font-size: 1rem;
    margin: auto;
}

.input_small{
    font-size: .8rem !important; 
}

</style>